import { useState, type ReactNode } from 'react';
import { MetrikaActivityTab, MetrikaTrafficTab } from './MetrikaChartTabs';
import { MetrikaSetupTab } from './MetrikaSetupTab';
import { MetrikaUsersTab } from './MetrikaUsersTab';
import { MetrikaUtmTab } from './MetrikaUtmTab';

const TABS: Array<{ id: string; title: string; content: ReactNode }> = [
  { id: 'setup', title: 'Настройка', content: <MetrikaSetupTab /> },
  { id: 'users', title: 'Пользователи', content: <MetrikaUsersTab /> },
  { id: 'activity', title: 'Активность', content: <MetrikaActivityTab /> },
  { id: 'traffic', title: 'Трафик', content: <MetrikaTrafficTab /> },
  { id: 'utm', title: 'Метки', content: <MetrikaUtmTab /> },
];

export const MetrikaPage = () => {
  const [activeId, setActiveId] = useState(TABS[0].id);
  const active = TABS.find((tab) => tab.id === activeId) ?? TABS[0];

  return (
    <>
      <section className="content-header">
        <h1>Аналитика</h1>
      </section>
      <section className="content">
        <ul className="nav nav-tabs">
          {TABS.map((tab) => (
            <li key={tab.id} className={tab.id === active.id ? 'active' : ''}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveId(tab.id);
                }}
              >
                {tab.title}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: 16 }}>{active.content}</div>
      </section>
    </>
  );
};
